import { Localized, useLocalization } from '@fluent/react';

import { InputFormik } from '#/components/controls/Input';
import { formatPhoneNumber } from '#/utils/formatter';

const ContactPointForm: React.FC<ContactPointFormProps> = ({ hiddenFields, name, showLabel }) => {
  const namePrefix = name ? `${name}.` : '';
  const { l10n } = useLocalization();

  return (
    <div className="space-y-2">
      <div>
        <Localized id="name" attrs={{ placeholder: true }}>
          <InputFormik
            label={showLabel ? l10n.getString('name') : undefined}
            name={`${namePrefix}name`}
          />
        </Localized>
      </div>

      {!hiddenFields?.includes('email') && (
        <div>
          <Localized id="email" attrs={{ placeholder: true }}>
            <InputFormik
              label={showLabel ? l10n.getString('email') : undefined}
              name={`${namePrefix}email`}
              type="email"
            />
          </Localized>
        </div>
      )}

      {!hiddenFields?.includes('telephone') && (
        <div>
          <Localized id="telephone" attrs={{ placeholder: true }}>
            <InputFormik
              formatter={formatPhoneNumber}
              label={showLabel ? l10n.getString('telephone') : undefined}
              name={`${namePrefix}telephone`}
              type="tel"
            />
          </Localized>
        </div>
      )}
    </div>
  );
};
export type ContactPointFormProps = {
  hiddenFields?: Array<'email' | 'telephone'>;
  name?: string;
  showLabel?: boolean;
};

export default ContactPointForm;
